import NavBar from '../NavBar';
import MarketingFooter from './MarketingFooter';

const MarketingLayout = ({ children }) => (
  <div className="marketing-site">
    <NavBar />
    <main>{children}</main>
    <MarketingFooter />
  </div>
);

export default MarketingLayout;